import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const DeleteAccount = () => {
  return (
    <section className="min-h-screen w-screen bg-gradient-to-b from-[#fefef8] to-[#fafae0] flex flex-col items-center Poppins">
      <Navbar />

      <div className="pt-[60px] w-full flex justify-center px-6">
        <div className="max-w-7xl w-full bg-white shadow-lg rounded-2xl border border-yellow-300 p-6 lg:p-10">
          <h1 className="text-3xl lg:text-4xl font-extrabold text-gray-800 text-center mb-6 tracking-wide">
            How to Delete Your Account
          </h1>
          <p className="text-center text-gray-500 mb-8">
            Last updated: <span className="font-medium">July 2026</span>
          </p>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Steps to Delete Your Account
              </h2>
              <div className="grid md:grid-cols-3 gap-4 mb-4">
                {/* Step 1 */}
                <div className="border rounded-lg p-3">
                  <p className="font-medium">1. Go to Profile</p>
                  <img src="/assets/delete-step1.png" alt="Step 1: Go to Profile" className="w-full h-auto rounded mb-2" />
                </div>
                
                {/* Step 2 */}
                <div className="border rounded-lg p-3">
                  <p className="font-medium">2. Click on Edit Profile</p>
                  <img src="/assets/delete-step2.png" alt="Step 2: Click on Edit Profile" className="w-full h-auto rounded mb-2" />
                </div>
                
                {/* Step 3 */}
                <div className="border rounded-lg p-3">
                  <p className="font-medium">3. Click on Delete Account</p>
                  <img src="/assets/delete-step3.jpeg" alt="Step 3: Click on Delete Account" className="w-full h-auto rounded mb-2" />
                </div>
              </div>
              <p className="font-medium">4. Read all descriptions carefully and click on "Delete my account"</p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                What Happens When You Delete Your Account
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Your personal data (name, email, profile info) will be permanently deleted.</li>
                <li>App usage history and settings will be erased.</li>
                <li>Any active orders will be canceled.</li>
                <li>You will be logged out immediately.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                What Data We Retain
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>We may keep financial transaction records for up to 6 years (for legal/tax compliance).</li>
                <li>Security-related logs may be stored for up to 12 months.</li>
                <li>Aggregated, anonymized data for analytics purposes.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Need Help?
              </h2>
              <p>If you have any questions about account deletion, contact us at:</p>
              <div className="mt-2 bg-gray-50 p-4 rounded-lg shadow-sm text-sm">
                <p>
                  <span className="font-medium">Email:</span> support@instaportdelivery.com
                </p>
                <p>
                  <span className="font-medium">Phone:</span> +91 8850166601
                </p>
                <p>
                  <span className="font-medium">Working Hours:</span> Mon–Sat : 
                  10am – 8pm, Sun : 10am - 6pm
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-red-400 pl-3 mb-3">
                Return to Privacy Policy
              </h2>
              <p>
                To review our full Privacy Policy, please visit:{" "}
                <Link
                  to="/privacy-policy"
                  className="text-blue-600 font-medium hover:underline"
                >
                  Privacy Policy
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default DeleteAccount;